import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID ,LOCALE_ID} from '@angular/core';
import { faArrowRight, faPlus } from '@fortawesome/free-solid-svg-icons';
import { NgbAccordionConfig, NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { BrokerageFirm } from 'src/app/core/models/brokerage-firm';
import { Page } from 'src/app/core/models/page';
import { SortData } from 'src/app/core/models/sort-data';
import { StockRecommendation } from 'src/app/core/models/stock-recommendation';
import { BrokerageFirmService } from 'src/app/core/services/brokerage-firm.service';
import { StockRecommendationService } from 'src/app/core/services/stock-recommendation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  domainURL=environment.domain+"/"+(this.localId+"").substring(0,2)+"/";
  faPlus=faPlus;
  faLArrR=faArrowRight;
  brokerageFirms:BrokerageFirm[];
  stockRecommendationList:StockRecommendation[]= [];
  emptyArray : StockRecommendation[];
  public isCollapsed = false;
  i:number;
  page = new Page();
  sorts=new Array();
  recommendationPage = new Page();
  recommendationSorts=new Array();
  toYear=(new Date()).getFullYear();

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(@Inject(DOCUMENT) private document: Document,
  @Inject(LOCALE_ID) private localId: Object,
  @Inject(PLATFORM_ID) private platformId: Object,
  public brokerageFirmService: BrokerageFirmService,
  private stockRecommendationService:StockRecommendationService,
  config: NgbAccordionConfig
  ) { 
    config.closeOthers = true;
		config.type = 'info';
  }
  
  ngOnDestroy(): void{
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
 }

  ngOnInit(): void {
    
    if (isPlatformBrowser(this.platformId)||isPlatformServer(this.platformId)) { 
    this.page = new Page();
      this.page.pageNumber = 1;
      this.page.size = 15;  
      this.setPage(this.page);
    }
  }
	public beforeChange($event: NgbPanelChangeEvent) {
    this.stockRecommendationList=[];
    this.recommendationPage = new Page();
    this.recommendationPage.pageNumber = 1;
    this.recommendationPage.size = 100;  

    this.setPageRecommendation(this.recommendationPage,$event.panelId);
	}
  setPage(page) {
    this.page = page;
    let sortData=new SortData<BrokerageFirm>();
    let suggestion = new BrokerageFirm();
    suggestion.lang="tr";
    suggestion.country="tr";
    suggestion.status=true;
    sortData.filter=suggestion;
    this.sorts=[{"dir": "asc", "prop": "brokerageFirm"}]
    sortData.sorts=this.sorts;
    this.page.pageNumber = this.page.pageNumber - 1;
    
    this.brokerageFirmService.getPageAbleList(this.page,sortData).pipe(takeUntil(this.destroy$)).subscribe(pagedData => {
      this.page = pagedData.page;
      this.brokerageFirms = pagedData.data;
      this.recommendationPage = new Page();
      this.recommendationPage.pageNumber = 1;
      this.recommendationPage.size = 100;  
      this.setPageRecommendation(this.recommendationPage,0);
    },
    error => {
      console.log("error: ",error);
    });
  }

  setPageRecommendation(page,id) {
    this.recommendationPage = page;
    let sortData=new SortData<StockRecommendation>();
    let suggestion = new StockRecommendation();
    suggestion.lang="tr";
    suggestion.country="tr";
    suggestion.brokerageFirm=this.brokerageFirms[id].name;
    suggestion.status=true;
    suggestion.type="TARGET";
    sortData.filter=suggestion;
    this.sorts=[{"dir": "asc", "prop": "brokerageFirm"}]
    sortData.sorts=this.sorts;
    this.recommendationPage.pageNumber = this.recommendationPage.pageNumber - 1;
    this.stockRecommendationService.getPageAbleList(this.recommendationPage,sortData).pipe(takeUntil(this.destroy$)).subscribe(pagedData => {
      this.recommendationPage = pagedData.page;
      this.stockRecommendationList = pagedData.data;

    },
    error => {
      console.log("error: ",error);
    });
  }


  public trackByFnSuggestion(index, item) {
    if (!item) return null;
    return item.id;
  }
  public trackByBrokerageFirm(index, item) {
    if (!item) return null;
    return item.id;
  }
  }


